<template>
<!-- eslint-disable max-len no-trailing-spaces -->
  <div>
    <div :style="{
      'position': 'relative', 
      'padding-top': '20px',
      'background-position': 'center center', 
      'background-size': 'cover',
      'background-repeat': 'no-repeat',
      'background-image': 'url(' + require('../../assets/sales_page/sales_page_header.jpg') + ')'}">
      <!-- <img alt="homepage" style="display: none;" :src="require('../../assets/sales_page/sales_page_header.jpg')"  rel="preload"/> -->

      <!-- Image left outside the content wrap so that it fills width -->
      <!-- <img alt="homepage" style="width:100%; margin-top: 0px; opacity: 20%;"
      :src="require('../../assets/sales_page/sales_page_header.jpg')"  rel="preload"/> -->
      <!-- <img alt="homepage" style="width:100%; margin-top: 0px; opacity: 0.8;" :src="require('../../assets/sales_page/sales_page_header.jpg')"  rel="preload"/> -->
      <div style="top: 0; width: 100%; height: 100%; position: absolute; z-index: 2; opacity:90%;
        background: #3bbfbf; background: linear-gradient(208deg,rgba(59, 191, 191, 1) 0%, rgba(10, 101, 120, 1) 84%);"></div>
      <!-- <div style="position: absolute; top: 50%; left: 3%; right: 3%; transform: translate(0%, -50%); z-index: 2;"> -->
      <div style="position: relative; padding: clamp(60px, 10vw, 100px) clamp(20px, 3vw, 30px); z-index: 2;">
        <h2 style="color: #FFFFFF; text-shadow: 0 0 30px rgba(0,0,0,0.2); font-size: clamp(24px, 25vw, 250%); line-height: 100%;">
          <p style="padding-bottom: 10px;">Driven To Electrify</p></h2>
        <!-- TODO should I put this font size calculation onto main headers? Or only neededd here? -->
        <h6 style="color: #FFFFFF; text-shadow: 0 0 30px rgba(0,0,0,0.2); font-size: clamp(18px, 2.5vw, 130%); line-height: 140%; font-weight: 500;">
          <p style="margin-bottom: 10px;">Driving Electrification with Intuitive Consumer Shopping Tools</p>
          <p style="margin-bottom: 0px;">Choose from our suite of options, readily customized to integrate into your online resources</p>
        </h6>
        <br>
      </div>
    </div>
    <div id="content-wrap">
    <div style="margin-top: 20px;"> 
      <!-- <h6 class="" style="text-decoration: underline; text-decoration-color: var(--accent); text-underline-offset: 10px;;"> Tool Options Include </h6> -->
      <div class="section-top"> 
        <div>
          <h5>
            Tools Options
          </h5>
        </div>
        <div>
          <span class="large"> Discover EVs, charging stations, and savings over time with our core tools.  </span> 
          <br>
          <span class="large"> Find nearby dealerships, public chargers, and more with our suite of offerings and custom app capacity.  </span>
        </div>
      </div>
      <div>
        <div style="width:100%;">

          <!-- <hr> -->
          <br>
          <div class="paragraphGroup">
            <h6 class="t6"> 
              <font-awesome-icon icon="fa-solid fa-car-side" class="iconMobile"/>
               <router-link class="inlineRouterLink" to="/driven/ev_comparison">Compare EVs</router-link>
            </h6>
            <div class="paragraphWithImage"> 
              <div class="paragraph">
                <span>
                  Effortlessly filter through all current electric vehicles (EVs) and plug-in hybrid.
                  Each vehicle listing includes a quality image, detailed information, tax incentive eligibility, and links to both the manufacturer page and our "Calculate Savings" tool, which showcases financial and environmental advantages over traditional gas vehicles.
                  <br><br>Users can:
                  <ul>
                   <li>Filter by make, vehicle type, and seating capacity </li>
                   <li>Search by keyword, make, model, and year</li>
                   <li>Sort vehicles by price, range, horsepower, and more</li>
                   <li>Compare specific vehicles with the "Compare Favorites" feature</li>
                   <li>Share a filtered list with "Copy Link"</li>
                 </ul>
                </span>
              </div>
              <img :src="require('../../assets/sales_page/1.jpg')" alt="test" class="itemBlock">
            </div>
            <hr>

            <h6 class="t6"> 
              <font-awesome-icon icon="fa-solid fa-charging-station" class="iconMobile"/>
               <router-link class="inlineRouterLink" to="/driven/charger_comparison">Compare Chargers</router-link>
            </h6>
            <div class="paragraphWithImage"> 
              <div class="paragraph">
                <span>
                  Locate the best EV charger for your home or business. Each charger includes product details and purchase/information links. Chargers are pre-screened for Energy Star and UL certification and the list is updated continuously.
                  <br><br>Your customers can:
                 <ul>
                   <li>Filter by make, plug type, and features </li>
                   <li>Search by keyword</li>
                   <li>Sort by price and amperage</li>
                   <li>Allows "Compare Favorites" and "Copy Link" functionality</li>
                 </ul>
                </span>
              </div>
              <img :src="require('../../assets/sales_page/2.jpg')" alt="test" class="itemBlock">
            </div>
          <hr>

            <h6 class="t6"> 
              <font-awesome-icon icon="fa-solid fa-money-bill" class="iconMobile"/>
               <router-link class="inlineRouterLink" to="/driven/savings_calculator">Calculate Savings</router-link>
            </h6>
            <div class="paragraphWithImage"> 
              <div class="paragraph">
                <span>
                  Calculate potential savings from driving electric with this powerful tool. Select from a list of EVs or click in directly from the EV Comparison tool to visualize potential financial benefits. Key features include:
                 <ul>
                   <li>Gas and electric prices default to your area’s average and can be further customized by users along with vehicle efficiencies and weekly driving amounts </li>
                   <li>Clean charts paired with specific highlighted numbers work together to help users understand fuel savings</li>
                   <li>Simultaneously capable of calculating CO2 emission reductions and includes the ability to customize emission coefficients to your locality</li>
                 </ul>
                </span>
              </div>
              <img :src="require('../../assets/sales_page/4.jpg')" alt="test" class="itemBlock">
            </div>
            <hr>

            <h6 class="t6"> 
              <font-awesome-icon icon="fa-solid fa-sack-dollar" class="iconMobile"/>
               <router-link class="inlineRouterLink" to="/driven/incentives">Find Incentives</router-link>
            </h6>
            <div class="paragraphWithImage"> 
              <div class="paragraph">
                <span>
                  Discover eligible home and transportation incentives customized to your criteria. We tailor the "Find Incentives" tool to reflect specific state, county, and city incentive programs. Your customers can:
                  <ul>
                    <li>Filter by eligibility criteria including zip code, income, and household size</li>
                    <li>Compare specific providers, categories, and discount types</li>
                    <li>Search by incentive titles and key terms</li>
                    <li>Conveniently access incentive program pages to apply or find out more</li>
                  </ul>
                </span>
              </div>
              <img :src="require('../../assets/sales_page/6.jpg')" alt="test" class="itemBlock">
            </div>
            <hr>
            <h6 class="t6"> 
              <font-awesome-icon icon="fa-solid fa-location-dot" class="iconMobile"/>
               <router-link class="inlineRouterLink" to="/driven/dealers">Dealership Tool</router-link>
            </h6>
            <div class="paragraphWithImage"> 
              <div class="paragraph">
                <span>
                  View a map and list of dealerships customized to your area, filterable by make, and sorted by distance from your location.
                  Dealership listings include:
                  <ul>
                    <li>Location, contact information, and website link</li>
                    <li>Easy access to directions</li>
                    <!-- <li>Capability to link directly to test drive signups</li> -->
                    <li>Partner dealerships can be additionally highlighted</li>
                  </ul>
                </span>
              </div>
              <img :src="require('../../assets/sales_page/7.jpg')" alt="test" class="itemBlock">
            </div>
            <hr>
            <h6 class="t6"> 
              <font-awesome-icon icon="fa-solid fa-star" class="iconMobile"/>
               Additional Tools
            </h6>
            <div class="paragraphWithImage"> 
              <div class="paragraph">
                <span>
                  Additional tools are available, including:
                  <ul>
                    <li>Locate public charging stations near you</li>
                    <li>Find new and used EVs for sale near you</li>
                    <li>Find electricians for charger installation</li>
                    <li>Display information on relevant events such as test drives</li>
                    <li>Educational and resource landing pages</li>
                    <li>Custom tools and pages purpose built for your needs</li>
                  </ul>
                </span>
              </div>
              <img :src="require('../../assets/sales_page/7.jpg')" alt="test" class="itemBlock">
            </div>
<!--             <hr>
            <h6 class="t6"> 
              <font-awesome-icon icon="fa-solid fa-circle-info" class="iconMobile"/>
                Education
            </div>
            <div class="paragraph">
              <span>
                Driven offers more than a decade of experience building educational content and web pages focused on electrification along with hands-on experience hosting webinars and in-person events. We leverage our extensive database of educational materials to create descriptive pages deeply linked to our tools and customized to your needs. These educational materials can be deeply integrated with our EV Tool offerings — for example, our EV Comparison tool can link to and be linked from pages highlighting EV benefits, comparing EVs and PHEVs, and more.
              </span>
            </div> -->
          </div>
          </div>
        </div>
<!--         <div style="">
          <b-carousel
            id="carousel-1"
            :interval="5000"
            :controls="true"
            :indicators="true"
            no-hover-pause
            no-animation
            style="margin: 0 auto; text-shadow: 0px 0px 2px #000"
            @sliding-start="onSlideStart"
            @sliding-end="onSlideEnd"
            v-model="slide"
          >
            <b-carousel-slide :img-src="require('../../assets/sales_page/1.png')"></b-carousel-slide>
            <b-carousel-slide :img-src="require('../../assets/sales_page/2.png')"></b-carousel-slide>
            <b-carousel-slide :img-src="require('../../assets/sales_page/3.png')"></b-carousel-slide>
            <b-carousel-slide :img-src="require('../../assets/sales_page/4.png')"></b-carousel-slide>
            <b-carousel-slide :img-src="require('../../assets/sales_page/5.png')"></b-carousel-slide>
            <b-carousel-slide :img-src="require('../../assets/sales_page/6.png')"></b-carousel-slide>
            <b-carousel-slide :img-src="require('../../assets/sales_page/7.png')"></b-carousel-slide>
          </b-carousel>
        </div> -->
      </div>

      <hr style="margin: 100px 0; border-top: 5px solid var(--accent); opacity: 0.6;">

      <div>
      <div class="section-top">
        <div>
          <h5>
            The Driven Advantage
          </h5>
        </div>
        <div>
          <span class="large"> Thorough customization, extensive accessibility features, real time analytics, and simple integration with your existing site. </span>
        </div>
      </div>
      <!-- <hr> -->
      <br>
      <div class="paragraphGroup">
        <h6 class="t6">
          <font-awesome-icon icon="fa-solid fa-wrench" class="iconMobile"/>Customization
        </h6>
        <div class="paragraph">
          <span>
            We tailor our tools to match your branding, including logos, colors, favicons, and more. We support regional customization of gas and electric prices, available incentives programs, dealerships, and charging stations. We also offer the ability to add custom text and links across the site to direct tool users back to relevant programs. Additionally, we have the capability to develop new tools to meet additional requirements and modify existing ones to provide desired features.
          </span>
        </div>

        <hr>
        <h6 class="t6">
          <font-awesome-icon icon="fa-solid fa-person" class="iconMobile"/>Accessibility
        </h6>
        <div class="paragraph">
          <span>
            Driven prioritizes inclusivity with screen reader support, language translation, keyboard navigation, and carefully reviewed copy for accessible reading levels. Our tools are not only functional but also visually appealing and user-friendly on mobile phones and tablets, ensuring accessibility at events and on the go.
          </span>
        </div>

        <hr>
        <h6 class="t6">
          <font-awesome-icon icon="fa-solid fa-chart-simple" class="iconMobile"/>Analytics
        </h6>
        <div class="paragraph">
          <span>
            We support detailed logging that feeds into a password-protected analytics dashboard, offering real time insights into tool usage trends and user preferences. This provides insights ranging from high level tracking of usage over time to granular views into the filters, sorting, and inputs of each tool.
          </span>
        </div>

        <hr>
        <h6 class="t6">
          <font-awesome-icon icon="fa-solid fa-gear" class="iconMobile"/>Implementation
        </h6>
        <div class="paragraph">
          <span>
            Our tools can be linked directly from your existing site, with consistent branding, favicons, site titles, and back links providing a continuity of experience for users. This makes the implementation as simple as adding new links into your site content and marketing materials. We can alternatively surface these tools using a subdomain of your existing site.
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- eslint-enable max-len -->
</template>

<script>

export default {
  data() {
    return {
      slide: 0,
      sliding: null,
    };
  },
  mounted() {
  },
  methods: {
    /* eslint-disable */
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    },
    /* eslint-enable'...' */
    getImgUrl(filename) {
      // Requires and gets route to image. Require setup here requires temporary lint disabling.
      // TODO we should consider a CDN setup to enable REACH members to easily add images.
      // Currently, charger images are added to /assets/EV_Chargers
      /* eslint-disable */
      try {
        return require(`../../assets/sales_page/${filename.image_url}`);
      }
      catch (e) {
        return '';
      }
      /* eslint-enable'...' */
    },
  },
  created() {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

ul { padding-top: 5px; }
ul li { padding: 5px; }

hr { margin: clamp(30px, 5vw, 50px) 0; }

/* See carousel-control-next styling in App vue for controls overrides */
.carousel {
  width:40%;
}

.container {
  /* Offset from header */
  /*margin-top: 0px;
  display: block;*/
}
/* Same margin bottom as paragraph*/
.textList {
/*  font-size:110%;*/
  margin-top: 0px;
  display: table;
  /*margin-left: 60px;*/
}

.sectionheader {
  margin-bottom: 20px;
  /*text-align: center;*/
}
.section-top {
  color: var(--accent);
  margin: 50px 0;
}
.section-top h5 {
  display: inline-block;
  margin-bottom: 20px;
}

.paragraph {
/*  font-size: 100%;*/
  margin-top: 20px;
/*  margin-left: 70px;*/
}
.paragraphGroup {

}

.iconContainer {
/*  align-items: center;*/
  justify-content: center;  /*horizontal*/
}
.iconMobile {
  margin: auto auto;
  height: 1.7em; /* 2em; */
  width: 1.7em;
  /*float: left;*/
  margin-right: 15px; /* 20px */
  /*padding: 20px;*/
  vertical-align: middle;
  /*margin-top:  10spx;*/
  /*display: block;*/
  clear: both;
  color: var(--accent);
  /*float:left;*/
}

.icon {
  margin: auto auto;
  width: 120px;
  float: left;
  margin-right: 40px;
  padding: 20px;
  /*vertical-align: middle;*/
  /*margin-top:  10spx;*/
  /*display: block;*/
  clear: both;
  /*float:left;*/
}

.paragraphGroup {
/*  margin-left: 20px;*/
}

.paragraphWithImage {
  display: flex;
  column-gap: 4%;
  flex-wrap: nowrap;
  flex-direction: row;
}
.paragraphWithImage .paragraph {
  /* width: 600px; */
  flex: 1 1 45%;
  /* max-width:100%; */
}
.paragraphWithImage img {
  display: flex;
  flex: 1 1 60%;
  /* max-width:100%; */
}
@media screen and (max-width: 1300px) {
  .paragraphWithImage {
    flex-direction: column;
  }
  .paragraphWithImage .paragraph {
    flex: 1 0 100%;
    margin-bottom: 30px;
  }
  .paragraphWithImage img {
    flex: 1 0 100%;
    margin-top: 0;
  }
}
.itemBlock {
  /* TODO FIGURE OUT HOW TO ALIGN AT THE TOPPP */
  display: flex; 
  justify-content: top;
  margin: 0;
  padding: 0;
/*  margin-bottom: auto;*/
/*  margin-top: 0;*/
/*  display: block;*/
/*align-self: top;*/
  width: 700px;
  max-width:80%;
  height: 100%;
  margin: 20px auto;
/*  align-self: center;*/
  padding: 10px;
/*  align-self: top;*/
/*  margin-left: auto;*/
}
img {
  margin: 0;
}

img {
  height: auto;
}

</style>
